<template>
    <div>
        <div class="app-title">
            <em-view-title ref="emViewTitle" v-bind:crudState="$_emWorkflowTaskMixin_pathType"></em-view-title>
        </div>
        <section class="app-content">
            <div id="entity-viewer" class="content" v-menu-permission="'list'">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <em-workflow-business-data-editor :entity="modelName"
                                                              :business-data="$_emWorkflowTaskMixin_businessData">
                            </em-workflow-business-data-editor>
                        </div>
                    </div>
                </div>
            </div>
            <div id="workflow-process_execution" class="content">
<!--                <em-workflow-process-execution :processDefinitionKey="$_emWorkflowTaskMixin_processDefinitionKey" :businessKey="$_emWorkflowTaskMixin_businessKey">-->
<!--                </em-workflow-process-execution>-->
              <WorkflowProcessLine :processDefinitionKey="$_emWorkflowTaskMixin_processDefinitionKey"
                                   ref="processExecution" @gotItems="setLocalVariables"
                                   :businessKey="$_emWorkflowTaskMixin_businessKey">
              </WorkflowProcessLine>
            </div>

            <div id="em-workflow-task-complete" class="content" v-if="$_emWorkflowTaskMixin_isShowTaskComplete">

                <WorkflowTaskComplete ref="processComplete"
                                      :task-id="$_emWorkflowTaskMixin_taskId"
                                      :businessKey="$_emWorkflowTaskMixin_businessKey"
                                      :status="$_emWorkflowTaskMixin_businessData.status"
                                      :callbackApi="$_emWorkflowTaskMixin_callbackApi"
                                      :config="processConfig">
                </WorkflowTaskComplete>
            </div>
        </section>
    </div>
</template>
<script>
    // Author thq
    // Date 2022-02-14 13:50:08

    import emWorkflowTaskMixin from "@/mixin/em/workflow/task";
    import workflowTaskMixins from "@/components/workflow/mixin/WorkflowTaskMixins";
    import WorkflowProcessLine from "@/components/workflow/stuffs/WorkflowProcessLine";
    import WorkflowTaskComplete from "@/components/workflow/stuffs/WorkflowTaskComplete";

    export default {
        name: "repairSppOrderWorkflowTaskView",
      components: {WorkflowProcessLine, WorkflowTaskComplete},
      mixins: [emWorkflowTaskMixin,workflowTaskMixins],
        computed: {
            modelName() {
                return this.$_emRouterHelperMixin_entityName
            },
          processConfig() {return {
            'task1': {
              name: '规划中',
              variables: [
                {
                  label: '提交类型',
                  type: this.VALUE_TYPE.SELECT,
                  saveTo: this.SAVE_TO.APPROVE,
                  options: [
                    {value: 1, text: '提交物管部审核'},
                    {value: 2, text: '作废维修工单'}
                  ],
                  changeTag: val =>{
                    return this.buildTag('tj',val === 1)
                  }
                },
                {
                  label: '外委维修厂家',
                  name: 'rsoRepFactory',
                  type: this.VALUE_TYPE.INPUT,
                  saveTo: this.SAVE_TO.DATABASE,
                  initData: true,
                  initDataName: 'rsoRepFactory',
                  require: true,
                  needTag: 'tj'
                },
                {
                  label: '送修日期',
                  name: 'rsoRepairDate',
                  type: this.VALUE_TYPE.DATETIME,
                  saveTo: this.SAVE_TO.DATABASE,
                  initData: true,
                  initDataName: 'rsoRepairDate',
                  require: true,
                  needTag: 'tj'
                }
              ],
              withAttachment: true,
              withComment: true
            },
            'task1_1': {
              name: '重新规划',
              variables: [
                {
                  label: '提交类型',
                  type: this.VALUE_TYPE.SELECT,
                  saveTo: this.SAVE_TO.APPROVE,
                  options: [
                    {value: 1, text: '再次提交物管部审核'},
                    {value: 2, text: '作废维修工单'}
                  ],
                  changeTag: val =>{
                    return this.buildTag('tj',val === 1)
                  }
                },
                {
                  label: '外委维修厂家',
                  name: 'rsoRepFactory',
                  type: this.VALUE_TYPE.INPUT,
                  saveTo: this.SAVE_TO.DATABASE,
                  initData: true,
                  initDataName: 'rsoRepFactory',
                  require: true,
                  needTag: 'tj'
                },
                {
                  label: '送修日期',
                  name: 'rsoRepairDate',
                  type: this.VALUE_TYPE.DATETIME,
                  saveTo: this.SAVE_TO.DATABASE,
                  initData: true,
                  initDataName: 'rsoRepairDate',
                  require: true,
                  needTag: 'tj'
                }
              ],
              withAttachment: true,
              withComment: true
            },
            'task2': {
              name: '物管部审核',
              variables: [
                {
                  label: '提交类型',
                  type: this.VALUE_TYPE.SELECT,
                  saveTo: this.SAVE_TO.APPROVE,
                  options: [
                    {value: 1, text: '提请采购部外委'},
                    {value: 2, text: '维修驳回'}
                  ]
                }
              ],
              withAttachment: true,
              withComment: true
            },
            'task2_1': {
              name: '物管部再次审核',
              variables: [
                {
                  label: '提交类型',
                  type: this.VALUE_TYPE.SELECT,
                  saveTo: this.SAVE_TO.APPROVE,
                  options: [
                    {value: 1, text: '提请采购部继续外委维修'},
                    {value: 2, text: '维修驳回'}
                  ]
                }
              ],
              withAttachment: true,
              withComment: true
            },
            'task3': {
              name: '采购部外委维修',
              variables: [
                {
                  label: '提交类型',
                  type: this.VALUE_TYPE.SELECT,
                  saveTo: this.SAVE_TO.APPROVE,
                  options: [
                    {value: 1, text: '提请验收'},
                    {value: 2, text: '维修退回'}
                  ],
                  changeTag: val =>{
                    return this.buildTag('tj',val === 1)
                  }
                },
                {
                  label: '修复时间',
                  name: 'rsoRestoreDate',
                  type: this.VALUE_TYPE.DATETIME,
                  saveTo: this.SAVE_TO.DATABASE,
                  require: true,
                  needTag: 'tj'
                }
              ],

              withAttachment: true,
              withComment: true
            },
            'task4': {
              name: '维修验收',
              variables: [
                {
                  label: '提交类型',
                  type: this.VALUE_TYPE.SELECT,
                  saveTo: this.SAVE_TO.APPROVE,
                  options: [
                    {value: 1, text: '验收完成'},
                    {value: 2, text: '维修驳回'}
                  ]
                }
              ],
              withAttachment: true,
              withComment: true
            },
            '*': {
              name: '大型备件外委维修工单',
              variables: [
                {
                  label: '提交类型',
                  type: this.VALUE_TYPE.SELECT,
                  saveTo: this.SAVE_TO.APPROVE,
                  options: [
                    {value: 1, text: '至下一任务'},
                    {value: 2, text: '驳回'}
                  ]
                }
              ],
              withAttachment: true,
              withComment: true
            }
          }}
        }
    };
</script>